import { JetView } from 'webix-jet'; // Importing JetView for creating a Webix view
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing Webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from Webix
import { providersCasino } from '../../../../config/config'; // Importing configuration for providers

/**
 * Class representing the filter view for deposit reports.
 * @extends JetView
 */
export default class FilterDepositReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration

        // Datepicker configuration
        const fecha = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for date selection
                    name: 'Datepicker',
                    id: 'Datepicker',
                    css: 'reportrange',
                    readonly: true, // Read-only input
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Placeholder text
                },
            ],
        };

        // Transaction ID input configuration
        const transactionId = {
            margin: 5,
            minWidth: 200,
            rows: [
                {
                    view: 'text', // Text input for transaction ID
                    name: 'TransactionId',
                    type: 'number', // Input type is number
                    label: _('Transacción ID'), // Label for the input
                    labelPosition: 'top',
                    placeholder: _('Transacción ID'), // Placeholder text
                    invalidMessage: _('Transacción ID is required'), // Validation message
                },
            ],
        };

        // Upper section layout configuration
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout
                    margin: 10,
                    cols: [
                        fecha, // Datepicker component
                        {
                            view: 'richselect', // Dropdown for selecting type
                            name: 'Type',
                            localId: 'provider:combo',
                            label: _('Tipo'), // Label for the dropdown
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            options: [
                                // Dropdown options
                                { id: '0', value: _('Mensual') },
                                { id: '1', value: _('Diario') },
                            ],
                        },
                    ],
                },
            ],
        };

        // Button configuration for actions
        const buttons = {
            margin: 10,
            minWidth: 200,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true,
                    click: () => {
                        // Click event to clear the form
                        this.getRoot().clear();
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form',
                    autowidth: true,
                    click: () => {
                        // Click event to filter reports
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('depositReport:filter', [filterdata]); // Trigger filter event
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Components in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
